export default __webpack_public_path__ + "static/media/gallery_04.df2def51.jpg";